import React, { useState } from 'react'
import { getFunnelContent, getPlanByPriceId, getLimitsForTier, getUserTier } from '../../shared/plans';
import posthogClient from '../../shared/posthogClient';

export default function UpsellSubscription({priceId, user, funnel}) {

  const salesText = getFunnelContent(priceId, funnel);
  const plan = getPlanByPriceId(priceId);
  const price = plan.unit_amount_in_cents / 100;

  const choosePlansLink = user.isZuulUser ? `${__ZUUL_URL}/account/subscription/edit` : `${__ZUUL_URL}/sign-up`;

  const [Success, SetSuccess] = useState(false);
  const [Processing, SetProcessing] = useState(false);

  const handleActivate = async () => {
    window.location.href = `${__ZUUL_URL}/account/subscription/edit`;
  }

  const renderButtonHint = () => {
    return (typeof salesText.buttonHint === 'function') ?
      salesText.buttonHint(user.subscription) :
      salesText.buttonHint;
  }

  const renderBillingContent = () => {
    return (typeof salesText.billingContent === 'function') ?
      salesText.billingContent(plan) :
      salesText.billingContent;
  }

  const renderTitle = () => {
    return (typeof salesText.title === 'function') ?
      salesText.title(plan, user) :
      salesText.title;
  }

  const renderForm = () => (
    <div style={{display: Success ? 'none' : 'block'}}>
      {salesText.title && (
        <div className='sales-modal-stage-header'>
          <h2>{renderTitle()}</h2>
          {salesText.subtitle && <p>{typeof salesText.subtitle === 'function' ? salesText.subtitle(plan) : salesText.subtitle}</p>}
        </div>
      )}

      {salesText.billingContent && renderBillingContent()}

      <button
        disabled={Processing || Success}
        className='sales-modal-button'
        onClick={handleActivate}
      >
        {Processing ? 'Processing...' : (salesText.buttonBilling || 'Subscribe now')}
      </button>

      {salesText.buttonHint && <p className='sales-modal-hint'>{renderButtonHint()}</p>}
    </div>
  )

  const renderDone = () => (
    <div className='sales-modal-done' style={{display: Success ? 'flex' : 'none'}}>
      <div className='big-tick'></div>
      <h2>Thank you.</h2>
      {salesText.doneHtml}
    </div>
  )

  return (
    <div className='sales-modal-container upsell-subscription'>
      {renderForm()}
      {renderDone()}
    </div>
  )
}
